import type { GuildIconKeys } from '@newComponents/GuildIcon/GuildIcon'

export type DocPage = {
  path: string
  label: string
}

export type DocSectionConfig = {
  path: string
  label: string
  icon: GuildIconKeys
  description: string
  pages: readonly DocPage[]
}

export const DOC_SECTIONS: readonly DocSectionConfig[] = [
  {
    path: 'getting-started',
    label: 'Getting Started',
    icon: 'star',
    description: 'Learn the basics of using Guild.',
    pages: [
      { path: 'overview', label: 'Overview' },
      { path: 'command-menu', label: 'Command Palette' },
      { path: 'search', label: 'Search' },
      { path: 'navigation', label: 'Navigation' },
    ],
  },
  {
    path: 'guilds',
    label: 'Guilds',
    icon: 'people',
    description: 'Create and manage your community.',
    pages: [
      { path: 'overview', label: 'Overview' },
      { path: 'creation', label: 'Creating a Guild' },
      { path: 'profile', label: 'Guild Profile' },
      { path: 'settings', label: 'Guild Settings' },
      { path: 'members', label: 'Managing Members' },
      { path: 'forms', label: 'Membership Forms' },
      { path: 'monetization', label: 'Monetization' },
      { path: 'messaging', label: 'Messaging' },
      { path: 'embeds', label: 'Embeds' },
      { path: 'bluesky', label: 'Bluesky' },
      { path: 'google-calendar', label: 'Google Calendar' },
      { path: 'meetup', label: 'Meetup Migration' },
      { path: 'calendar-feeds', label: 'Calendar Feeds' },
    ],
  },
  {
    path: 'events',
    label: 'Events',
    icon: 'calendar',
    description: 'Host gatherings with ticketing, RSVPs, and check-in.',
    pages: [
      { path: 'overview', label: 'Overview' },
      { path: 'creation', label: 'Creating an Event' },
      { path: 'page', label: 'Event Page' },
      { path: 'settings', label: 'Event Settings' },
      { path: 'multi-host', label: 'Multi-Host Events' },
      { path: 'rsvps', label: 'RSVPs & Attendees' },
      { path: 'attendee-forms', label: 'Attendee Forms' },
      { path: 'check-in', label: 'Check-In' },
      { path: 'visibility', label: 'Visibility' },
      { path: 'ticketing-overview', label: 'Ticketing Overview' },
      { path: 'stripe', label: 'Setting Up Stripe' },
      { path: 'tiers', label: 'Ticketing Tiers' },
      { path: 'discounts', label: 'Discount Codes' },
      { path: 'orders', label: 'Orders & Refunds' },
      { path: 'purchase-flow', label: 'Attendee Purchase Flow' },
      { path: 'messages', label: 'Event Messages' },
      { path: 'embeds', label: 'Embeds' },
    ],
  },
  {
    path: 'presentations',
    label: 'Presentations',
    icon: 'projection-screen',
    description: 'Share talks, slides, and recordings.',
    pages: [
      { path: 'overview', label: 'Overview' },
      { path: 'creation', label: 'Creating a Presentation' },
      { path: 'claiming', label: 'Claiming a Presentation' },
      { path: 'page', label: 'Presentation Page' },
      { path: 'embeds', label: 'Embeds' },
    ],
  },
  {
    path: 'account',
    label: 'Your Account',
    icon: 'person',
    description: 'Manage your profile, settings, and security.',
    pages: [
      { path: 'overview', label: 'Overview' },
      { path: 'sign-in', label: 'Sign Up & Sign In' },
      { path: 'profile', label: 'Your Profile' },
      { path: 'joining', label: 'Joining a Guild' },
      { path: 'notifications', label: 'Notification Settings' },
      { path: 'security', label: 'Authentication & Security' },
      { path: 'calendar', label: 'Calendar Sync' },
      { path: 'embeds', label: 'Embeds' },
    ],
  },
] as const
